import { render, staticRenderFns } from "./HorseAjoutByTranspondeur.vue?vue&type=template&id=f921668c&"
import script from "./HorseAjoutByTranspondeur.vue?vue&type=script&lang=js&"
export * from "./HorseAjoutByTranspondeur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports